import { useState, useEffect } from 'react'
import {
  Form,
  Typography,
  Space,
  Card,
  notification,
  Row,
  Col,
  Spin,
  Button,
  Modal as ModalAntd,
  Input as InputAntd,
  Affix,
} from 'antd'
import { useStoreState, useStoreActions } from 'easy-peasy'
import _ from 'lodash'
import { useAsync } from 'react-use'
import { Radio } from 'antd'

import Input from 'components/Input'
import InputNumber from 'components/InputNumber'
import TextArea from 'components/TextArea'
import Select from 'components/Select'
import DatePicker from 'components/DatePicker'
import Upload from 'components/Upload'

import { useTranslate } from 'hooks/translate'

import { getReportTypeAttributeListApi } from 'services/reportType/attribute'
import { getDictionaryValueFilterListApi } from 'services/filter/dictionary/value'

import numeral from 'utils/numeral'
import { convertDayCodeToTargetDate } from 'utils/date'
import { evil } from 'utils'
import moment from 'utils/moment'
import {
  createMyIncidentApi,
  updateMyIncidentApi,
  updateSubmitMyIncidentApi,
  updateRejectMyIncidentApi,
  updateReOpenMyIncidentApi,
} from 'services/myIncident'
import {
  getReportAttachmentApi,
  postReportAttachmentApi,
  deleteReportAttachmentApi,
} from 'services/ReportAttachment'
import { useHistory } from 'react-router-dom'
import Styled from './styled'
import Investigation from '../../pages/MyIncident/components/Investigation'
import Invite from '../../pages/MyIncident/components/RequestInformation'
import ActionPlan from '../../pages/MyIncident/components/ActionPlan'
import { convertOrganizationalStructureToFilters } from 'utils/organization'
import { LockOutlined, UnlockOutlined, SyncOutlined } from '@ant-design/icons'
export default function ReportIncident ({
  id,
  hederId,
  header,
  reportStatusId,
  reportData,
  action,
  riskCo,
  canEdit,
  canSelectAssignee,
  isReportOwnself,
  riskOwnself,
  riskOwnerOrg,
  assigneeOptions,
  isCentralReporter,
  riskcoList,
  riskCoOrg,
  setValidAssignee,
}) {
  const history = useHistory()
  const { t } = useTranslate()
  const [form] = Form.useForm()
  const { employee, user_id } = JSON.parse(localStorage.user)

  const [loading, setLoading] = useState(false)
  const [reportType, setReportType] = useState({})
  const [reportTypeAttributes, setReportTypeAttributes] = useState([])
  const [allDictionaryValues, setAllDictionaryValues] = useState({})
  const [radioValue, setRadioValue] = useState('report')
  const [attachFile, setAttachFile] = useState([])
  const [attachID, setAttachID] = useState([])
  const [attachCode, setAttachCode] = useState([])

  const [data, setData] = useState(null)
  const [reportImpactLevel, setReportImpactLevel] = useState([])
  const [reportOverall, setReportOverall] = useState({})
  const [openReportOverall, setOpenReportOverall] = useState(false)
  const [assigneeValue, setAssigneeValue] = useState(null)
  const [reject_des, setRejectDes] = useState('')
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false)
  const [checkIndex, setCheckIndex] = useState([])

  const reportStatuses = useStoreState((state) => state.filter.reportStatuses)
  const groupAttributes = useStoreState((state) => state.filter.groupAttributes)
  const dataTypes = useStoreState((state) => state.filter.dataTypes)
  const dictionaries = useStoreState((state) => state.filter.dictionaries)
  const days = useStoreState((state) => state.filter.days)
  const getReportStatuses = useStoreActions((actions) => actions.filter.getReportStatuses)
  const getGroupAttributes = useStoreActions((actions) => actions.filter.getGroupAttributes)
  const getDataTypes = useStoreActions((actions) => actions.filter.getDataTypes)
  const getDictionaries = useStoreActions((actions) => actions.filter.getDictionaries)
  const getDays = useStoreActions((actions) => actions.filter.getDays)
  const org = JSON.parse(localStorage.getItem('org'))
  const isRiskAnalyst =
    JSON.parse(localStorage.getItem('user'))?.profile?.role?.role_name === 'Risk Analyst'
  useAsync(async () => {
    Promise.all([
      getReportStatuses({ forceGet: true }),
      getGroupAttributes({ forceGet: true }),
      getDataTypes({ forceGet: true }),
      getDictionaries({ forceGet: true }),
      getDays({ forceGet: true }),
    ])
  }, [])

  // useAsync(async () => {
  //   if (hederId) {
  //     // getFile()
  //   }
  // }, [hederId])

  useAsync(async () => {
    if (riskCo && +reportStatusId !== 4 && !hederId) {
      const orgStructureRiskco = riskCo?.employee?.org_structure || ''
      form.setFieldsValue({
        risk_co: riskCo?.employee?.employee_name_th,
        risk_co_profile: orgStructureRiskco
          ? orgStructureRiskco?.section?.section_name !== 'N/A'
            ? orgStructureRiskco?.section?.section_name
            : orgStructureRiskco?.department?.department_name !== 'N/A'
            ? orgStructureRiskco?.department?.department_name
            : orgStructureRiskco?.division?.division_name !== 'N/A'
            ? orgStructureRiskco?.division?.division_name
            : orgStructureRiskco?.business_unit?.bu_name !== 'N/A'
            ? orgStructureRiskco?.business_unit?.bu_name
            : orgStructureRiskco?.group?.group_name !== 'N/A'
            ? orgStructureRiskco?.group?.group_name
            : orgStructureRiskco?.company?.company_name || ''
          : '',
      })
    }
  }, [riskCo])

  useAsync(async () => {
    if (reportData) {
      setData(reportData)
    }
    setReportOverall({
      impact_level_before_id: reportData.impact_level_before_id,
      likelihood_level_before_id: reportData.likelihood_level_before_id,
      risk_level_before_id: reportData.risk_level_before_id,
      is_significant: reportData.is_significant,
    })
  }, [reportData])

  useAsync(async () => {
    const params = {
      report_type_id: id,
      is_active: true,
      page: 1,
      size: 100,
    }
    const res = await getReportTypeAttributeListApi(params)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }
    setReportTypeAttributes(res.data?.items)
  }, [])

  useAsync(async () => {
    if (!_.isEmpty(dictionaries)) {
      const results = await _.reduce(
        dictionaries,
        async (result, dictionary) => {
          const res = await getDictionaryValueFilterListApi(dictionary.id)

          return {
            ...(await result),
            [dictionary.id]: res?.data,
          }
        },
        Promise.resolve({})
      )

      setAllDictionaryValues(results)
    }
  }, [dictionaries])

  useEffect(() => {
    if (reportStatusId) {
      form.setFieldsValue({
        reportStatus: reportStatusId,
        status: reportStatusId,
      })
    }
  }, [reportStatusId, form])

  useAsync(async () => {
    if (attachID.length > 0 && attachID[attachID.length - 1] && hederId) {
      const filesRes = await getReportAttachmentApi({
        report_header_id: hederId,
        report_task_id: null,
        report_attribute_value_id: attachID[attachID.length - 1],
      })

      const tempData = []

      filesRes?.data.map((item) => {
        tempData.push({
          uid: item?.report_attachment_id,
          name: item?.file_path.substring(item?.file_path.lastIndexOf('/') + 1),
          status: 'done',
          url: `${process.env.REACT_APP_SERVICE_URL}${item.file_path}`,
        })
      })
      if (attachCode[attachCode.length - 1]) {
        setAttachFile((prev) => {
          let update = [...prev]
          if (prev[attachCode.length - 1]) {
            update[attachCode.length - 1] = tempData
          } else {
            update.push(tempData)
          }
          return update
        })
        form.setFieldsValue({
          [attachCode[attachCode.length - 1]]: tempData,
          files: tempData,
        })
      }
    }
  }, [attachID, attachCode, reportData])

  useEffect(() => {
    if (riskCoOrg) {
      form.setFieldsValue({
        risk_co_profile: riskCoOrg,
      })
    }
  }, [riskCoOrg, form])

  useEffect(() => {
    if (riskOwnself) {
      form.setFieldsValue({
        risk_owner_company_id: riskOwnself,
      })
    }
  }, [riskOwnself, form])

  useEffect(() => {
    if (riskOwnerOrg) {
      form.setFieldsValue({
        risk_owner_org: riskOwnerOrg?.value || null,
      })
    }
  }, [riskOwnerOrg, form])

  useAsync(async () => {
    if (reportData) {
      // form.setFieldsValue({
      //   reportStatus: reportStatusId,
      // })
      let formData = form.getFieldValue()
      let formKeys = Object.keys(formData)
      formKeys?.map((key) => {
        if (reportData?.key) {
          console.log('-=-=-=-=-=-=-', reportData?.key)
        } else if (reportData?.reporter) {
          let assignee = ''
          if (reportStatusId === 1) {
            assignee = reportData?.assignee?.employee?.employee_name_th
            setAssigneeValue(reportData?.assignee?.user_id)
          } else if (reportStatusId === 2) {
            assignee = reportData?.assignee?.employee?.employee_name_th
            setAssigneeValue(reportData?.assignee?.user_id)
          } else if (reportStatusId === 3) {
            assignee = reportData?.assignee?.employee?.employee_name_th
            setAssigneeValue(reportData?.assignee?.user_id)
          } else if (
            [4, 5, 6, 7, 8].includes(reportStatusId) &&
            reportData?.assignee?.user_id &&
            canSelectAssignee
          ) {
            assignee = reportData?.assignee?.employee?.employee_name_th || ''
            setAssigneeValue(reportData?.assignee?.user_id)
            if ([6, 5, 4].includes(reportStatusId) && reportData?.riskanalyst_id) {
              assignee = reportData?.riskanalyst?.employee?.employee_name_th || ''
              setAssigneeValue(reportData?.riskanalyst_id)
            }
            if ([7, 8].includes(reportStatusId) && reportData?.riskapprover_id) {
              assignee = reportData?.riskapprover?.employee?.employee_name_th || ''
              setAssigneeValue(reportData?.riskapprover_id)
            }
          }
          if (canSelectAssignee && assigneeOptions && assignee) {
            setValidAssignee(true)
          }
          const orgStructureRiskco = reportData?.riskcoordinator?.employee?.org_structure || ''
          const orgStructureReporter = reportData?.reporter?.employee?.org_structure || ''

          form.setFieldsValue({
            incident_topic: reportData?.incident_topic || '',
            reporter_profile: orgStructureReporter
              ? orgStructureReporter?.section?.section_name !== 'N/A'
                ? orgStructureReporter?.section?.section_name
                : orgStructureReporter?.department?.department_name !== 'N/A'
                ? orgStructureReporter?.department?.department_name
                : orgStructureReporter?.division?.division_name !== 'N/A'
                ? orgStructureReporter?.division?.division_name
                : orgStructureReporter?.business_unit?.bu_name !== 'N/A'
                ? orgStructureReporter?.business_unit?.bu_name
                : orgStructureReporter?.group?.group_name !== 'N/A'
                ? orgStructureReporter?.group?.group_name
                : orgStructureReporter?.company?.company_name || ''
              : '',
            reporter: reportData?.reporter?.employee?.employee_name_th || '',
            risk_co_profile: orgStructureRiskco
              ? orgStructureRiskco?.section?.section_name !== 'N/A'
                ? orgStructureRiskco?.section?.section_name
                : orgStructureRiskco?.department?.department_name !== 'N/A'
                ? orgStructureRiskco?.department?.department_name
                : orgStructureRiskco?.division?.division_name !== 'N/A'
                ? orgStructureRiskco?.division?.division_name
                : orgStructureRiskco?.business_unit?.bu_name !== 'N/A'
                ? orgStructureRiskco?.business_unit?.bu_name
                : orgStructureRiskco?.group?.group_name !== 'N/A'
                ? orgStructureRiskco?.group?.group_name
                : orgStructureRiskco?.company?.company_name || ''
              : '',
            risk_co: reportData?.riskcoordinator?.employee?.employee_name_th || '',
            reporter_date: moment(reportData?.report_date, 'YYYY-MM-DD')
              ? moment(reportData?.report_date, 'YYYY-MM-DD')
              : moment(reportData?.report_date)
              ? moment(reportData?.report_date)
              : null,
            validate_date: reportData?.validate_date
              ? moment(reportData?.validate_date, 'YYYY-MM-DD')
              : null,
            risk_owner_company_id: reportData?.risk_owner
              ? [
                  `${reportData?.risk_owner_company[0]?.company_id || 0}-${
                    reportData?.risk_owner_group[0]?.group_id || 0
                  }-${reportData?.risk_owner_business_unit[0]?.bu_id || 0}`,
                ]
              : ['2-7-29'],
            assignee: assignee || '',
            reportcode_cd: reportData?.reportcode_cd || '',
            investigate_code: reportData?.investigatecode_cd || '',
            section: reportData?.business_process_id,
            risk_owner_org: reportData?.risk_owner_org || null,
            risk_owner_user_id: reportData?.risk_owner_user.map((item) => item?.user_id) || [],
            reject_description: reportData?.reject_description || '',
            report_status: reportData?.report_status?.report_status_name_en || '',
            // risk_owner_business_unit: [29],
            // risk_owner_department,
            // risk_owner_division,
            // risk_owner_group,
            // risk_owner_section
          })
        }
        // reporter_profile
        // profile
        reportData?.report_attribute_value.map((v) => {
          if (v?.report_type_attribute?.report_type_attribute_code === key) {
            let value = v?.report_type_attribute_report_value
            let valueTypes = dataTypes.find((t) => t?.id === v?.report_type_attribute?.data_type_id)
            if (valueTypes?.name === 'date' && value) {
              value = moment(value, 'YYYY-MM-DD')
            } else if (['integer', 'float', 'calculation'].includes(valueTypes?.name)) {
              value = +value
            }
            if (!attachCode.includes(key))
              form.setFieldsValue({
                [key]: value,
              })
          }
          return v
        })

        if (reportData?.report_attribute_value) return key
      })
    }
  }, [reportData, form, dataTypes, reportStatusId, canSelectAssignee])

  const renderInputByType = ({ record }) => {
    let valid = (reportStatusId === 8 || reportStatusId === 7) && isRiskAnalyst
    const dataTypeName = _.find(dataTypes, { id: record?.data_type_id })?.name
    if (reportStatusId !== 1 && reportData?.report_attribute_value) {
      let checkAtt = reportData?.report_attribute_value.find((at) => {
        return (
          at?.report_type_attribute?.report_type_attribute_code ===
          record?.report_type_attribute_code
        )
      })
      if (!checkAtt) {
        return null
      }
    }
    switch (dataTypeName) {
      case 'text': {
        const textProps = {
          placeholder: record?.report_type_attribute_name,
        }
        return (
          <Form.Item
            initialValue={record?.default_value_str}
            label={
              +reportStatusId === 5 && isRiskAnalyst ? (
                <>
                  {record?.report_type_attribute_name}{' '}
                  <Button
                    onClick={() => {
                      setData((prev) => {
                        let updateLock = prev?.report_attribute_value?.map((v) => {
                          if (
                            v?.report_type_attribute?.report_type_attribute_code ===
                            record?.report_type_attribute_code
                          ) {
                            return { ...v, is_locked: !v?.is_locked }
                          } else {
                            return v
                          }
                        })
                        return { ...prev, report_attribute_value: updateLock }
                      })
                    }}
                    shape='circle'
                    type={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked
                        ? 'primary'
                        : 'default'
                    }
                    icon={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked ? (
                        <LockOutlined />
                      ) : (
                        <UnlockOutlined />
                      )
                    }
                  />
                </>
              ) : (
                record?.report_type_attribute_name
              )
            }
            name={record?.report_type_attribute_code}
            rules={
              valid
                ? []
                : [
                    {
                      required: !record?.is_nullable,
                      message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                    },
                    {
                      type: 'string',
                      min: record?.min_length,
                      max: record?.max_length,
                    },
                  ]
            }
          >
            {record?.row_size > 1 ? (
              <TextArea
                {...textProps}
                rows={record?.row_size / 50}
                disabled={!canEdit}
                style={{ color: 'black' }}
              />
            ) : (
              <Input {...textProps} disabled={!canEdit} style={{ color: 'black' }} />
            )}
            {/* {} */}
          </Form.Item>
        )
      }

      case 'integer': {
        const integerProps = {
          precision: 0,
          style: { width: '100%' },
        }

        return (
          <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
              const getMinQtyValue = () => {
                let result = null

                if (record?.min_qty_type === 'None') {
                } else if (record?.min_qty_type === 'Direct') {
                  result = record?.min_qty_value
                } else if (record?.min_qty_type === 'Attribute') {
                  const reportTypeAttribute = _.find(reportTypeAttributes, {
                    report_type_attribute_id: record?.min_qty_attribute_id,
                  })
                  result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                }

                return result
              }

              const getMaxQtyValue = () => {
                let result = null

                if (record?.max_qty_type === 'None') {
                } else if (record?.max_qty_type === 'Direct') {
                  result = record?.max_qty_value
                } else if (record?.max_qty_type === 'Attribute') {
                  const reportTypeAttribute = _.find(reportTypeAttributes, {
                    report_type_attribute_id: record?.max_qty_attribute_id,
                  })
                  result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                }

                return result
              }

              const getExtra = (minQtyValue, maxQtyValue) => {
                let result = null

                if (minQtyValue || maxQtyValue) {
                  const minQtyValueFormat = numeral(minQtyValue || 0).format('0,0')
                  const maxQtyValueFormat = numeral(maxQtyValue || 0).format('0,0')
                  result = `(${minQtyValueFormat} - ${maxQtyValueFormat})`
                }

                return result
              }

              const minQtyValue = getMinQtyValue()
              const maxQtyValue = getMaxQtyValue()
              const extra = getExtra(minQtyValue, maxQtyValue)

              return (
                <Form.Item
                  initialValue={record?.default_value_int}
                  label={
                    +reportStatusId === 5 && isRiskAnalyst ? (
                      <>
                        {record?.report_type_attribute_name}{' '}
                        <Button
                          onClick={() => {
                            setData((prev) => {
                              let updateLock = prev?.report_attribute_value?.map((v) => {
                                if (
                                  v?.report_type_attribute?.report_type_attribute_code ===
                                  record?.report_type_attribute_code
                                ) {
                                  return { ...v, is_locked: !v?.is_locked }
                                } else {
                                  return v
                                }
                              })
                              return { ...prev, report_attribute_value: updateLock }
                            })
                          }}
                          shape='circle'
                          type={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked
                              ? 'primary'
                              : 'default'
                          }
                          icon={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked ? (
                              <LockOutlined />
                            ) : (
                              <UnlockOutlined />
                            )
                          }
                        />
                      </>
                    ) : (
                      record?.report_type_attribute_name
                    )
                  }
                  name={record?.report_type_attribute_code}
                  rules={
                    valid
                      ? []
                      : [
                          {
                            required: !record?.is_nullable,
                            message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                          },
                          {
                            type: 'number',
                            min: minQtyValue,
                            max: maxQtyValue,
                          },
                        ]
                  }
                  extra={extra}
                >
                  <InputNumber
                    {...integerProps}
                    disabled={!canEdit}
                    style={{ color: 'black', width: '100%' }}
                  />
                </Form.Item>
              )
            }}
          </Form.Item>
        )
      }

      case 'float': {
        const floatProps = {
          precision: record?.max_decimal,
          style: { width: '100%' },
        }

        return (
          <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
              const getMinQtyValue = () => {
                let result = null

                if (record?.min_qty_type === 'None') {
                } else if (record?.min_qty_type === 'Direct') {
                  result = record?.min_qty_value
                } else if (record?.min_qty_type === 'Attribute') {
                  const reportTypeAttribute = _.find(reportTypeAttributes, {
                    report_type_attribute_id: record?.min_qty_attribute_id,
                  })
                  result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                }

                return result
              }

              const getMaxQtyValue = () => {
                let result = null

                if (record?.max_qty_type === 'None') {
                } else if (record?.max_qty_type === 'Direct') {
                  result = record?.max_qty_value
                } else if (record?.max_qty_type === 'Attribute') {
                  const reportTypeAttribute = _.find(reportTypeAttributes, {
                    report_type_attribute_id: record?.max_qty_attribute_id,
                  })
                  result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                }

                return result
              }

              const getExtra = (minQtyValue, maxQtyValue) => {
                let result = null

                if (minQtyValue || maxQtyValue) {
                  const minQtyValueFormat = numeral(minQtyValue || 0).format('0,0')
                  const maxQtyValueFormat = numeral(maxQtyValue || 0).format('0,0')
                  result = `(${minQtyValueFormat} - ${maxQtyValueFormat})`
                }

                return result
              }

              const minQtyValue = getMinQtyValue()
              const maxQtyValue = getMaxQtyValue()
              const extra = getExtra(minQtyValue, maxQtyValue)

              return (
                <Form.Item
                  initialValue={record?.default_value_int}
                  label={
                    +reportStatusId === 5 && isRiskAnalyst ? (
                      <>
                        {record?.report_type_attribute_name}{' '}
                        <Button
                          onClick={() => {
                            setData((prev) => {
                              let updateLock = prev?.report_attribute_value?.map((v) => {
                                if (
                                  v?.report_type_attribute?.report_type_attribute_code ===
                                  record?.report_type_attribute_code
                                ) {
                                  return { ...v, is_locked: !v?.is_locked }
                                } else {
                                  return v
                                }
                              })
                              return { ...prev, report_attribute_value: updateLock }
                            })
                          }}
                          shape='circle'
                          type={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked
                              ? 'primary'
                              : 'default'
                          }
                          icon={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked ? (
                              <LockOutlined />
                            ) : (
                              <UnlockOutlined />
                            )
                          }
                        />
                      </>
                    ) : (
                      record?.report_type_attribute_name
                    )
                  }
                  name={record?.report_type_attribute_code}
                  rules={
                    valid
                      ? []
                      : [
                          {
                            required: !record?.is_nullable,
                            message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                          },
                          {
                            type: 'number',
                            min: minQtyValue,
                            max: maxQtyValue,
                          },
                        ]
                  }
                  extra={extra}
                >
                  <InputNumber
                    {...floatProps}
                    disabled={!canEdit}
                    style={{ color: 'black', width: '100%' }}
                  />
                </Form.Item>
              )
            }}
          </Form.Item>
        )
      }

      case 'dictionary': {
        const dictionaryValues = allDictionaryValues?.[record?.dictionary_id]
        if (!hederId) {
          form.setFieldsValue({
            [record?.report_type_attribute_code]: dictionaryValues
              ? dictionaryValues.find((dic) => +dic?.id === +record?.default_dictionary_value_id)
                  ?.name || null
              : null,
          })
        }
        return (
          <Form.Item
            initialValue={
              !hederId
                ? dictionaryValues
                  ? dictionaryValues.find(
                      (dic) => +dic?.id === +record?.default_dictionary_value_id
                    )?.name || null
                  : null
                : null
            }
            label={
              +reportStatusId === 5 && isRiskAnalyst ? (
                <>
                  {record?.report_type_attribute_name}{' '}
                  <Button
                    onClick={() => {
                      setData((prev) => {
                        let updateLock = prev?.report_attribute_value?.map((v) => {
                          if (
                            v?.report_type_attribute?.report_type_attribute_code ===
                            record?.report_type_attribute_code
                          ) {
                            return { ...v, is_locked: !v?.is_locked }
                          } else {
                            return v
                          }
                        })
                        return { ...prev, report_attribute_value: updateLock }
                      })
                    }}
                    shape='circle'
                    type={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked
                        ? 'primary'
                        : 'default'
                    }
                    icon={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked ? (
                        <LockOutlined />
                      ) : (
                        <UnlockOutlined />
                      )
                    }
                  />
                </>
              ) : (
                record?.report_type_attribute_name
              )
            }
            name={record?.report_type_attribute_code}
            rules={
              valid
                ? []
                : [
                    {
                      required: !record?.is_nullable,
                      message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                    },
                  ]
            }
          >
            <Select
              options={_.map(dictionaryValues, (dictionaryValue) => {
                return {
                  label: dictionaryValue?.name,
                  value: dictionaryValue?.name,
                }
              })}
              style={{ width: '100%', color: 'black' }}
              disabled={!canEdit}
            />
          </Form.Item>
        )
      }

      case 'date': {
        return (
          <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
              const getInitialValue = () => {
                let result = null

                if (record?.default_value_type === 'day') {
                  if (record?.default_day_id) {
                    const day = _.find(days, { id: record?.default_day_id })
                    result = convertDayCodeToTargetDate(day?.value_list_code)
                  }
                }

                return result
              }

              const getMinDate = () => {
                let result = null

                if (record?.min_date_type === 'None') {
                } else if (record?.min_date_type === 'day') {
                  if (record?.min_day_id) {
                    const day = _.find(days, { id: record?.min_day_id })
                    result = convertDayCodeToTargetDate(day?.value_list_code)
                  }
                } else if (record?.min_date_type === 'attribute') {
                  if (record?.min_date_attribute_id) {
                    const reportTypeAttribute = _.find(reportTypeAttributes, {
                      report_type_attribute_id: record?.min_date_attribute_id,
                    })
                    result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                  }
                }

                return result
              }

              const getMaxDate = () => {
                let result = null

                if (record?.max_date_type === 'None') {
                } else if (record?.max_date_type === 'day') {
                  if (record?.max_day_id) {
                    const day = _.find(days, { id: record?.max_day_id })
                    result = convertDayCodeToTargetDate(day?.value_list_code)
                  }
                } else if (record?.max_date_type === 'attribute') {
                  if (record?.max_date_attribute_id) {
                    const reportTypeAttribute = _.find(reportTypeAttributes, {
                      report_type_attribute_id: record?.max_date_attribute_id,
                    })
                    result = getFieldValue(reportTypeAttribute?.report_type_attribute_code)
                  }
                }

                return result
              }

              const initialValue = getInitialValue()
              const minDate = getMinDate()
              const maxDate = getMaxDate()

              return (
                <Form.Item
                  initialValue={initialValue}
                  label={
                    +reportStatusId === 5 && isRiskAnalyst ? (
                      <>
                        {record?.report_type_attribute_name}{' '}
                        <Button
                          onClick={() => {
                            setData((prev) => {
                              let updateLock = prev?.report_attribute_value?.map((v) => {
                                if (
                                  v?.report_type_attribute?.report_type_attribute_code ===
                                  record?.report_type_attribute_code
                                ) {
                                  return { ...v, is_locked: !v?.is_locked }
                                } else {
                                  return v
                                }
                              })
                              return { ...prev, report_attribute_value: updateLock }
                            })
                          }}
                          shape='circle'
                          type={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked
                              ? 'primary'
                              : 'default'
                          }
                          icon={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked ? (
                              <LockOutlined />
                            ) : (
                              <UnlockOutlined />
                            )
                          }
                        />
                      </>
                    ) : (
                      record?.report_type_attribute_name
                    )
                  }
                  name={record?.report_type_attribute_code}
                  rules={
                    valid
                      ? []
                      : [
                          {
                            required: !record?.is_nullable,
                            message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                          },
                        ]
                  }
                >
                  <DatePicker
                    disabledDate={(current) => {
                      if (!current) return false

                      if (minDate) {
                        if (current.isBefore(minDate, 'day')) {
                          return true
                        }
                      }

                      if (maxDate) {
                        if (current.isAfter(maxDate, 'day')) {
                          return true
                        }
                      }

                      return false
                    }}
                    style={{ width: '100%', color: 'black' }}
                    disabled={!canEdit}
                  />
                </Form.Item>
              )
            }}
          </Form.Item>
        )
      }

      case 'calculation': {
        return (
          <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
              let initialValue = null

              if (record?.cal_equation) {
                let str = record?.cal_equation
                const codes = str.match(/{([^}]+)}/g)

                _.forEach(codes, (code) => {
                  const data = getFieldValue(code.slice(1, -1)) || 0
                  str = _.replace(str, code, data >= 0 ? data : ` ${data}`)
                })
                initialValue = evil(str) || evil(str) === 0 ? evil(str) : str
              }
              if (initialValue !== form.getFieldValue(record?.report_type_attribute_code)) {
                form.setFieldsValue({ [record?.report_type_attribute_code]: initialValue })
              }
              return (
                <Form.Item
                  initialValue={initialValue}
                  label={
                    +reportStatusId === 5 && isRiskAnalyst ? (
                      <>
                        {record?.report_type_attribute_name}{' '}
                        <Button
                          onClick={() => {
                            setData((prev) => {
                              let updateLock = prev?.report_attribute_value?.map((v) => {
                                if (
                                  v?.report_type_attribute?.report_type_attribute_code ===
                                  record?.report_type_attribute_code
                                ) {
                                  return { ...v, is_locked: !v?.is_locked }
                                } else {
                                  return v
                                }
                              })
                              return { ...prev, report_attribute_value: updateLock }
                            })
                          }}
                          shape='circle'
                          type={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked
                              ? 'primary'
                              : 'default'
                          }
                          icon={
                            data?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                record?.report_type_attribute_code
                            )?.is_locked ? (
                              <LockOutlined />
                            ) : (
                              <UnlockOutlined />
                            )
                          }
                        />
                      </>
                    ) : (
                      record?.report_type_attribute_name
                    )
                  }
                  name={record?.report_type_attribute_code}
                >
                  <InputNumber
                    disabled
                    placeholder={record?.report_type_attribute_name}
                    style={{ width: '100%', color: 'black' }}
                  />
                </Form.Item>
              )
            }}
          </Form.Item>
        )
      }

      case 'attachment': {
        // let check = false
        if (!attachID.includes(record?.report_type_attribute_id)) {
          setAttachID([...attachID, record?.report_type_attribute_id])
          setAttachCode([...attachCode, record?.report_type_attribute_code])
          // let f = getFile(record?.report_type_attribute_id, record?.report_type_attribute_code)
          // check = true
        }
        return (
          <Form.Item
            label={
              +reportStatusId === 5 && isRiskAnalyst ? (
                <>
                  {record?.report_type_attribute_name}{' '}
                  <Button
                    onClick={() => {
                      setData((prev) => {
                        let updateLock = prev?.report_attribute_value?.map((v) => {
                          if (
                            v?.report_type_attribute?.report_type_attribute_code ===
                            record?.report_type_attribute_code
                          ) {
                            return { ...v, is_locked: !v?.is_locked }
                          } else {
                            return v
                          }
                        })
                        return { ...prev, report_attribute_value: updateLock }
                      })
                    }}
                    shape='circle'
                    type={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked
                        ? 'primary'
                        : 'default'
                    }
                    icon={
                      data?.report_attribute_value.find(
                        (att) =>
                          att?.report_type_attribute?.report_type_attribute_code ===
                          record?.report_type_attribute_code
                      )?.is_locked ? (
                        <LockOutlined />
                      ) : (
                        <UnlockOutlined />
                      )
                    }
                  />
                </>
              ) : (
                record?.report_type_attribute_name
              )
            }
            name={record?.report_type_attribute_code}
            rules={
              valid
                ? []
                : [
                    {
                      required: !record?.is_nullable,
                      message: `กรุณากรอกข้อมูล ${record?.report_type_attribute_name}`,
                    },
                    {
                      validator: async (rule, value) => {
                        const isFileSizeExceeded = _.some(value, (file) => {
                          return file.size / 1024 / 1024 > record?.max_size
                        })

                        if (isFileSizeExceeded) {
                          return Promise.reject(
                            new Error(`File size must smaller than ${record?.max_size}MB!`)
                          )
                        }

                        return Promise.resolve()
                      },
                    },
                  ]
            }
          >
            <Upload multiple disabled={!canEdit || !hederId} />
          </Form.Item>
        )
      }

      default: {
        return null
      }
    }
  }

  const deleteFileNotUse = async (noDelIds, report_type_attribute_code) => {
    const delIds = []
    let index = attachCode.indexOf(report_type_attribute_code)
    if (index || index === 0) {
      _.map(attachFile[index], (item) => {
        if (noDelIds.includes(item.uid)) {
        } else {
          delIds.push(item.uid)
        }
      })
    }
    console.log('delIds', delIds)

    if (delIds.length > 0) {
      const res = await deleteReportAttachmentApi(delIds)

      if (res.status === 'error') {
        notification.error({
          message: 'Failed',
          description: res.message,
        })

        return
      }
    }
  }

  const uploadFiles = async (
    files,
    report_header_id,
    report_task_id,
    report_attribute_value_id,
    report_type_attribute_code
  ) => {
    const uploadFile = []
    const oldFile = []

    files.map((item) => {
      if (item?.status === 'done') {
        oldFile.push(item.uid)
      } else {
        uploadFile.push(item.originFileObj)
      }
    })

    if (oldFile.length > 0) {
      deleteFileNotUse(oldFile, report_type_attribute_code)
    }

    if (files.length === 0) {
      deleteFileNotUse([], report_type_attribute_code)
    }
    if (uploadFile.length > 0) {
      const res = await postReportAttachmentApi(uploadFile, {
        report_header_id: report_header_id,
        report_task_id: report_task_id,
        report_attribute_value_id: report_attribute_value_id,
      })

      if (res.status === 'error') {
        notification.error({
          message: 'Failed',
          description: res.message,
        })
        return
      }
    }
  }

  const recovery = () => {
    let setData = {}
    if (data?.report_attribute_value) {
      data?.report_attribute_value.map((item) => {
        if (!item?.is_locked) {
          const dataTypeName = _.find(dataTypes, {
            id: item?.report_type_attribute?.data_type_id,
          })?.name
          switch (dataTypeName) {
            case 'text':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  item?.report_type_attribute_investigate_value,
              }
              break
            case 'integer':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  +item?.report_type_attribute_investigate_value || 0,
              }
              break
            case 'float':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  +item?.report_type_attribute_investigate_value || 0,
              }
              break
            case 'dictionary':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  item?.report_type_attribute_investigate_value,
              }
              break
            case 'calculation':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  +item?.report_type_attribute_investigate_value || 0,
              }
              break
            case 'date':
              setData = {
                ...setData,
                [item?.report_type_attribute?.report_type_attribute_code]:
                  item?.report_type_attribute_investigate_value
                    ? moment(item?.report_type_attribute_investigate_value, 'YYYY-MM-DD')
                    : null,
              }
              break
            default: {
            }
          }
        }
        return item
      })
    }
    form.setFieldsValue(setData)
  }

  const genReport = (st) => {
    const currentReportStatus = st?.id
    let filterReportTypeAttributes = reportTypeAttributes

    if (currentReportStatus) {
      filterReportTypeAttributes = _.filter(reportTypeAttributes, {
        report_status_id: currentReportStatus,
      })
    }

    const groupReportTypeAttributes = _.groupBy(filterReportTypeAttributes, 'attribute_group_id')

    const orderGroupAttributes = _.orderBy(groupAttributes, ['order'], ['asc'])
    let orderGroupReportTypeAttributes = []
    _.forEach(orderGroupAttributes, (groupAttribute) => {
      const reportTypeAttributes = _.find(
        groupReportTypeAttributes,
        (reportTypeAttributes, attributeGroupId) => {
          return groupAttribute.id === Number(attributeGroupId)
        }
      )
      if (reportTypeAttributes) {
        if (isRiskAnalyst && hederId) {
          let check = reportTypeAttributes.map((rta) => {
            return !!reportData?.report_attribute_value.find((at) => {
              return (
                at?.report_type_attribute?.report_type_attribute_code ===
                rta?.report_type_attribute_code
              )
            })
          })
          if (check.includes(true)) {
            orderGroupReportTypeAttributes.push({
              ...groupAttribute,
              reportTypeAttributes,
            })
          }
        } else {
          orderGroupReportTypeAttributes.push({
            ...groupAttribute,
            reportTypeAttributes,
          })
        }
      }
    })
    return orderGroupReportTypeAttributes.length > 0 ? (
      <Form.Item
        shouldUpdate={(prevValues, curValues) => prevValues.reportStatus !== curValues.reportStatus}
      >
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          {_.map(orderGroupReportTypeAttributes, (orderGroupReportTypeAttribute, index) => {
            const groupAttribute = _.find(groupAttributes, {
              id: orderGroupReportTypeAttribute.id,
            })
            const reportTypeAttributes = orderGroupReportTypeAttribute?.reportTypeAttributes
            const groupLines = _.groupBy(reportTypeAttributes, 'report_line')
            return (
              <div key={index}>
                <Typography.Text>{groupAttribute?.name}</Typography.Text>
                <Card>
                  <Space direction='vertical' size='small' style={{ width: '100%' }}>
                    {_.map(groupLines, (groupLineReportTypeAttributes, line) => {
                      const span = 24 / _.size(groupLineReportTypeAttributes)
                      const orderReportTypeAttributes = _.orderBy(
                        groupLineReportTypeAttributes,
                        ['report_order'],
                        ['asc']
                      )
                      return (
                        <Row key={line} gutter={16}>
                          {_.map(orderReportTypeAttributes, (reportTypeAttribute, index) => {
                            return (
                              <Col key={index} xs={24} sm={24} md={24} lg={span}>
                                {renderInputByType({
                                  record: reportTypeAttribute,
                                })}
                              </Col>
                            )
                          })}
                        </Row>
                      )
                    })}
                  </Space>
                </Card>
              </div>
            )
          })}
        </Space>
      </Form.Item>
    ) : null
  }

  return (
    <Styled>
      {/* {console.log('checkIndex', checkIndex)} */}
      <Spin spinning={loading}>
        <Form
          form={form}
          // layout='vertical'
          onFieldsChange={(changedFields) => {
            if (changedFields[0] && changedFields[0]?.name.includes('assignee')) {
              setValidAssignee(!!changedFields[0]?.value)
            }
          }}
          initialValues={{
            reportStatus: reportStatusId,
            reporter: employee?.employee_name_th,
            reporter_profile: org
              ? org?.section?.section_name !== 'N/A'
                ? org?.section?.section_name
                : org?.department?.department_name !== 'N/A'
                ? org?.department?.department_name
                : org?.division?.division_name !== 'N/A'
                ? org?.division?.division_name
                : org?.business_unit?.bu_name !== 'N/A'
                ? org?.business_unit?.bu_name
                : org?.group?.group_name !== 'N/A'
                ? org?.group?.group_name
                : org?.company?.company_name || ''
              : '',
            reporter_date: moment(),
          }}
          onFinish={async (vvv) => {
            let values = form.getFieldValue()
            let attfile = []

            if (action === 'submit') {
              let check = openReportOverall
                ? reportOverall?.risk_level_before_id
                : reportData?.risk_level_before_id
              if (isReportOwnself && check === null) {
                return ModalAntd.error({
                  title: 'ไม่สามารถบันทึกได้',
                  content:
                    'สำหรับการรายงานหน่วยงานตนเอง ผู้ใช้งานจำเป็นต้องกรอกข้อมูลใน tab Investigation โปรดระบุ Impact Level และ Likelihood Level อย่างน้อย 1 ด้าน',
                })
              }
              ModalAntd.confirm({
                title: 'Confirm submit',
                icon: null,
                maskClosable: true,
                closeIcon: true,
                content: <div></div>,
                okButtonProps: {
                  shape: 'round',
                },
                okText: 'Submit',
                okType: 'primary',
                cancelButtonProps: {
                  shape: 'round',
                },
                cancelText: 'Cancel',
                onOk: async () => {
                  ModalAntd.warning({
                    title: <>ระบบกำลังบันทึกข้อมูล กรุณารอสักครู่</>,
                    icon: <SyncOutlined spin />,
                    maskClosable: false,
                    closeIcon: false,
                    okButtonProps: {
                      shape: 'round',
                      style: { display: 'none' },
                    },
                    content: (
                      <div style={{ color: 'red' }}>
                        *อาจใช้เวลานานกว่าปกติหากเอกสารแนบมีขนาดใหญ่
                      </div>
                    ),
                  })
                  if (reportData) {
                    let report_attribute_value = await Promise.all(
                      reportTypeAttributes.map(async (item) => {
                        const dataTypeName = _.find(dataTypes, { id: item?.data_type_id })?.name
                        if (values[item?.report_type_attribute_code] === undefined) {
                          if (reportData?.report_attribute_value) {
                            let recordAtt = reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                item?.report_type_attribute_code
                            )
                            if (recordAtt) {
                              return {
                                report_type_id: id,
                                report_type_attribute_id: item?.report_type_attribute_id,
                                report_attribute_value_id:
                                  reportData?.report_attribute_value.find(
                                    (att) =>
                                      att?.report_type_attribute_id ===
                                      item?.report_type_attribute_id
                                  )?.report_attribute_value_id || item?.report_attribute_value_id,
                                is_dictionary: dataTypeName === 'dictionary',
                                is_attachment: dataTypeName === 'attachment',
                                report_type_attribute_report_value:
                                  recordAtt?.report_type_attribute_report_value || '',
                                report_type_attribute_investigate_value:
                                  recordAtt?.report_type_attribute_investigate_value || '',
                                is_locked: false,
                                report_header_id: hederId,
                              }
                            }
                          }
                        }
                        if (
                          dataTypeName === 'attachment' &&
                          values[item?.report_type_attribute_code]
                        ) {
                          await uploadFiles(
                            values[item?.report_type_attribute_code],
                            hederId,
                            null,
                            item?.report_type_attribute_id,
                            item?.report_type_attribute_code
                          )

                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value: '',
                            report_type_attribute_investigate_value: '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                        if (dataTypeName === 'dictionary') {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || '',
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || '',
                            is_locked: false,
                            report_header_id: hederId,
                            dictionary_value_code:
                              allDictionaryValues?.[item?.dictionary_id].find(
                                (dic) => dic.name === values[item?.report_type_attribute_code]
                              )?.code || null,
                          }
                        }
                        if (dataTypeName === 'date') {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value: values[
                              item?.report_type_attribute_code
                            ]
                              ? moment(values[item?.report_type_attribute_code]).format(
                                  'YYYY-MM-DD'
                                )
                              : '',
                            report_type_attribute_investigate_value: values[
                              item?.report_type_attribute_code
                            ]
                              ? moment(values[item?.report_type_attribute_code]).format(
                                  'YYYY-MM-DD'
                                )
                              : '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                        if ([3, 4].includes(+item?.data_type_id)) {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || 0,
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || 0,
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        } else {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || '',
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                      })
                    )

                    let data = {
                      ...reportData,
                      risk_owner_company_id: [],
                      risk_owner_group_id: [],
                      risk_owner_bu_id: [],
                      risk_owner_division_id: [],
                      risk_owner_department_id: [],
                      risk_owner_section_id: [],
                      ...convertOrganizationalStructureToFilters(values?.risk_owner_company_id, [
                        'risk_owner_company_id',
                        'risk_owner_group_id',
                        'risk_owner_bu_id',
                        'risk_owner_division_id',
                        'risk_owner_department_id',
                        'risk_owner_section_id',
                      ]),
                      incident_topic: values?.incident_topic,
                      // report_date: moment().format('YYYY-MM-DD'),
                      // report_date: moment().format(),
                      business_process_id: values?.section,
                      report_attribute_value: report_attribute_value,
                      risk_owner_org: values?.risk_owner_org,
                      risk_owner_user_id: values?.risk_owner_user_id,
                    }
                    if (openReportOverall) {
                      let report_header_impact_level = reportImpactLevel?.filter(
                        (item) => item?.impact_level_after_id || item?.impact_level_before_id
                      )
                      data = {
                        ...data,
                        report_header_impact_level: report_header_impact_level || [],
                        impact_level_before_id: reportOverall?.impact_level_before_id,
                        likelihood_level_before_id: reportOverall?.likelihood_level_before_id,
                        impact_level_after_id: reportOverall?.impact_level_after_id,
                        likelihood_level_after_id: reportOverall?.likelihood_level_after_id,
                        risk_level_before_id: reportOverall?.risk_level_before_id,
                        is_significant: reportOverall?.is_significant,
                      }
                    }
                    let assigneeOptionValue = null
                    if (assigneeOptions.length > 0 || false) {
                      assigneeOptionValue =
                        assigneeOptions.find(
                          (item) =>
                            item?.label === form.getFieldValue()?.assignee ||
                            item?.user_id === form.getFieldValue()?.assignee
                        )?.user_id || null
                    }
                    if (reportStatusId === 4 || reportStatusId === 5) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        riskanalyst_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else if (reportStatusId === 2) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue
                          ? assigneeOptionValue
                          : reportData?.riskcoordinator_id
                          ? reportData?.riskcoordinator_id
                          : assigneeValue || null,
                      }
                    } else if (reportStatusId === 3) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        validate_date: moment().format('YYYY-MM-DD'),
                        riskcoordinator_id: assigneeOptionValue
                          ? assigneeOptionValue
                          : assigneeValue,
                      }
                    } else if (reportStatusId === 6) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else if (reportStatusId === 1 && isRiskAnalyst) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        reporter_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    }

                    if ((reportStatusId === 5 || reportStatusId === 6) && values?.status) {
                      data = {
                        ...data,
                        report_status_id: values?.status,
                      }
                    }
                    if (reportStatusId === 8) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else if ((reportStatusId === 5 || reportStatusId === 6) && isRiskAnalyst) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        riskanalyst_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    }
                    if (isCentralReporter) {
                      data = {
                        ...data,
                        riskcoordinator_id: riskcoList.find(
                          (item) =>
                            item?.label === values?.risk_co || item?.value === values?.risk_co
                        )?.value
                          ? riskcoList.find(
                              (item) =>
                                item?.label === values?.risk_co || item?.value === values?.risk_co
                            )?.value
                          : reportData?.riskcoordinator_id,
                      }
                    }
                    let res = await updateMyIncidentApi({
                      report_header_id: hederId,
                      data: data,
                    })
                    if (res?.status === 'success') {
                      let res = await updateSubmitMyIncidentApi({ report_header_id: hederId })
                      console.log('res', res)
                      if (res?.status === 'success') {
                        history.go(0)
                      } else if (res?.status === 'error') {
                        ModalAntd.destroyAll()

                        ModalAntd.error({
                          title: 'ไม่สามารถบันทึกได้',
                          content: res?.message || '',
                        })
                      }
                    }
                  } else {
                    let report_attribute_value = reportTypeAttributes.map((item) => {
                      const dataTypeName = _.find(dataTypes, { id: item?.data_type_id })?.name
                      if (dataTypeName === 'dictionary') {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          report_attribute_value_id:
                            reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute_id === item?.report_type_attribute_id
                            )?.report_attribute_value_id || item?.report_attribute_value_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || '',
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || '',
                          is_locked: false,
                          report_header_id: hederId,
                          dictionary_value_code:
                            allDictionaryValues?.[item?.dictionary_id].find(
                              (dic) => dic.name === values[item?.report_type_attribute_code]
                            )?.code || null,
                        }
                      }
                      if (dataTypeName === 'date') {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          report_attribute_value_id:
                            reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute_id === item?.report_type_attribute_id
                            )?.report_attribute_value_id || item?.report_attribute_value_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value: values[
                            item?.report_type_attribute_code
                          ]
                            ? moment(values[item?.report_type_attribute_code]).format('YYYY-MM-DD')
                            : '',
                          report_type_attribute_investigate_value: values[
                            item?.report_type_attribute_code
                          ]
                            ? moment(values[item?.report_type_attribute_code]).format('YYYY-MM-DD')
                            : '',
                          is_locked: false,
                          report_header_id: hederId,
                        }
                      }
                      if ([3, 4].includes(+item?.data_type_id)) {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || 0,
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || 0,
                          is_locked: false,
                        }
                      } else {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || '',
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || '',
                          is_locked: false,
                        }
                      }
                    })
                    let res = await createMyIncidentApi({
                      risk_owner_company_id: [],
                      risk_owner_group_id: [],
                      risk_owner_bu_id: [],
                      risk_owner_division_id: [],
                      risk_owner_department_id: [],
                      risk_owner_section_id: [],
                      ...convertOrganizationalStructureToFilters(values?.risk_owner_company_id, [
                        'risk_owner_company_id',
                        'risk_owner_group_id',
                        'risk_owner_bu_id',
                        'risk_owner_division_id',
                        'risk_owner_department_id',
                        'risk_owner_section_id',
                      ]),
                      report_status_id: 1,
                      report_type_id: id,
                      reporter_id: +user_id,
                      incident_topic: values?.incident_topic,
                      riskcoordinator_id: isCentralReporter
                        ? riskcoList.find(
                            (item) =>
                              item?.label === values?.risk_co || item?.value === values?.risk_co
                          )?.value
                        : riskCo?.user_id,

                      assignee_id: +user_id,
                      // report_date: moment().format('YYYY-MM-DD'),
                      report_date: moment().format(),
                      business_process_id: values?.section,
                      report_attribute_value,
                      report_header_impact_level: [],
                      risk_owner_org: values?.risk_owner_org,
                      risk_owner_user_id: values?.risk_owner_user_id || [],
                    })
                    if (res?.status === 'success' && res?.data?.report_header_id) {
                      let res1 = await updateSubmitMyIncidentApi({ report_header_id: hederId })
                      if (res1?.status === 'success') {
                        history.push(`/incident-report/${id}/${res?.data?.report_header_id}`)
                        if (res1?.status === 'success') {
                          history.go(0)
                        }
                      }
                    }
                  }
                },
              })
            } else if (action === 'save') {
              let check = openReportOverall
                ? reportOverall?.risk_level_before_id
                : reportData?.risk_level_before_id
              // console.log(
              //   isReportOwnself,
              //   reportData?.risk_level_before_id,
              //   reportOverall?.risk_level_before_id,
              //   'openReportOverall',
              //   openReportOverall
              // )
              if (isReportOwnself && check === null) {
                return ModalAntd.error({
                  title: 'ไม่สามารถบันทึกได้',
                  content:
                    'สำหรับการรายงานหน่วยงานตนเอง ผู้ใช้งานจำเป็นต้องกรอกข้อมูลใน tab Investigation โปรดระบุ Impact Level และ Likelihood Level อย่างน้อย 1 ด้าน',
                })
              }

              ModalAntd.confirm({
                title: 'Confirm save',
                icon: null,
                maskClosable: true,
                closeIcon: true,
                content: <div></div>,
                okButtonProps: {
                  shape: 'round',
                },
                okText: 'Save',
                okType: 'primary',
                cancelButtonProps: {
                  shape: 'round',
                },
                cancelText: 'Cancel',
                onOk: async () => {
                  ModalAntd.warning({
                    title: <>ระบบกำลังบันทึกข้อมูล กรุณารอสักครู่</>,
                    icon: <SyncOutlined spin />,
                    maskClosable: false,
                    closeIcon: false,
                    okButtonProps: {
                      shape: 'round',
                      style: { display: 'none' },
                    },
                    content: (
                      <div style={{ color: 'red' }}>
                        *อาจใช้เวลานานกว่าปกติหากเอกสารแนบมีขนาดใหญ่
                      </div>
                    ),
                  })
                  if (reportData) {
                    let report_attribute_value = await Promise.all(
                      reportTypeAttributes.map(async (item) => {
                        const dataTypeName = _.find(dataTypes, { id: item?.data_type_id })?.name
                        if (values[item?.report_type_attribute_code] === undefined) {
                          if (reportData?.report_attribute_value) {
                            let recordAtt = reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute?.report_type_attribute_code ===
                                item?.report_type_attribute_code
                            )
                            if (recordAtt) {
                              return {
                                report_type_id: id,
                                report_type_attribute_id: item?.report_type_attribute_id,
                                report_attribute_value_id:
                                  reportData?.report_attribute_value.find(
                                    (att) =>
                                      att?.report_type_attribute_id ===
                                      item?.report_type_attribute_id
                                  )?.report_attribute_value_id || item?.report_attribute_value_id,
                                is_dictionary: dataTypeName === 'dictionary',
                                is_attachment: dataTypeName === 'attachment',
                                report_type_attribute_report_value:
                                  recordAtt?.report_type_attribute_report_value || '',
                                report_type_attribute_investigate_value:
                                  recordAtt?.report_type_attribute_investigate_value || '',
                                is_locked: false,
                                report_header_id: hederId,
                              }
                            }
                          }
                        }
                        if (
                          dataTypeName === 'attachment' &&
                          values[item?.report_type_attribute_code]
                        ) {
                          await uploadFiles(
                            values[item?.report_type_attribute_code],
                            hederId,
                            null,
                            item?.report_type_attribute_id,
                            item?.report_type_attribute_code
                          )

                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value: '',
                            report_type_attribute_investigate_value: '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                        if (dataTypeName === 'dictionary') {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || '',
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || '',
                            is_locked: false,
                            report_header_id: hederId,
                            dictionary_value_code:
                              allDictionaryValues?.[item?.dictionary_id].find(
                                (dic) => dic.name === values[item?.report_type_attribute_code]
                              )?.code || null,
                          }
                        }
                        if (dataTypeName === 'date') {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value: values[
                              item?.report_type_attribute_code
                            ]
                              ? moment(values[item?.report_type_attribute_code]).format(
                                  'YYYY-MM-DD'
                                )
                              : '',
                            report_type_attribute_investigate_value: values[
                              item?.report_type_attribute_code
                            ]
                              ? moment(values[item?.report_type_attribute_code]).format(
                                  'YYYY-MM-DD'
                                )
                              : '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                        if ([3, 4].includes(+item?.data_type_id)) {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || 0,
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || 0,
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        } else {
                          return {
                            report_type_id: id,
                            report_type_attribute_id: item?.report_type_attribute_id,
                            report_attribute_value_id:
                              reportData?.report_attribute_value.find(
                                (att) =>
                                  att?.report_type_attribute_id === item?.report_type_attribute_id
                              )?.report_attribute_value_id || item?.report_attribute_value_id,
                            is_dictionary: dataTypeName === 'dictionary',
                            is_attachment: dataTypeName === 'attachment',
                            report_type_attribute_report_value:
                              values[item?.report_type_attribute_code] || '',
                            report_type_attribute_investigate_value:
                              values[item?.report_type_attribute_code] || '',
                            is_locked: false,
                            report_header_id: hederId,
                          }
                        }
                      })
                    )

                    let data = {
                      ...reportData,
                      risk_owner_company_id: [],
                      risk_owner_group_id: [],
                      risk_owner_bu_id: [],
                      risk_owner_division_id: [],
                      risk_owner_department_id: [],
                      risk_owner_section_id: [],
                      ...convertOrganizationalStructureToFilters(values?.risk_owner_company_id, [
                        'risk_owner_company_id',
                        'risk_owner_group_id',
                        'risk_owner_bu_id',
                        'risk_owner_division_id',
                        'risk_owner_department_id',
                        'risk_owner_section_id',
                      ]),
                      incident_topic: values?.incident_topic,
                      // report_date: moment().format('YYYY-MM-DD'),
                      // report_date: moment().format(),
                      business_process_id: values?.section,
                      report_attribute_value: report_attribute_value,
                      risk_owner_org: values?.risk_owner_org,
                      risk_owner_user_id: values?.risk_owner_user_id,
                    }
                    if (openReportOverall) {
                      let report_header_impact_level = reportImpactLevel?.filter(
                        (item) => item?.impact_level_after_id || item?.impact_level_before_id
                      )
                      data = {
                        ...data,
                        report_header_impact_level: report_header_impact_level || [],
                        impact_level_before_id: reportOverall?.impact_level_before_id,
                        likelihood_level_before_id: reportOverall?.likelihood_level_before_id,
                        impact_level_after_id: reportOverall?.impact_level_after_id,
                        likelihood_level_after_id: reportOverall?.likelihood_level_after_id,
                        risk_level_before_id: reportOverall?.risk_level_before_id,
                        is_significant: reportOverall?.is_significant,
                      }
                    }
                    let assigneeOptionValue = null
                    if (assigneeOptions.length > 0 || false) {
                      assigneeOptionValue =
                        assigneeOptions.find(
                          (item) =>
                            item?.label === form.getFieldValue()?.assignee ||
                            item?.user_id === form.getFieldValue()?.assignee
                        )?.user_id || null
                    }

                    if (reportStatusId === 4 || reportStatusId === 5) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        riskanalyst_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else if (reportStatusId === 2) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue
                          ? assigneeOptionValue
                          : reportData?.riskcoordinator_id
                          ? reportData?.riskcoordinator_id
                          : assigneeValue || null,
                      }
                    } else if (reportStatusId === 3) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        validate_date: moment().format('YYYY-MM-DD'),
                        riskcoordinator_id: assigneeOptionValue
                          ? assigneeOptionValue
                          : assigneeValue,
                      }
                    } else if (reportStatusId === 1 && isRiskAnalyst) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        reporter_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    }
                    if ((reportStatusId === 5 || reportStatusId === 6) && values?.status) {
                      data = {
                        ...data,
                        report_status_id: values?.status,
                      }
                    }
                    if (reportStatusId === 8) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    } else if ((reportStatusId === 5 || reportStatusId === 6) && isRiskAnalyst) {
                      data = {
                        ...data,
                        assignee_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                        riskanalyst_id: assigneeOptionValue ? assigneeOptionValue : assigneeValue,
                      }
                    }
                    if (isCentralReporter) {
                      data = {
                        ...data,
                        riskcoordinator_id: riskcoList.find(
                          (item) =>
                            item?.label === values?.risk_co || item?.value === values?.risk_co
                        )?.value
                          ? riskcoList.find(
                              (item) =>
                                item?.label === values?.risk_co || item?.value === values?.risk_co
                            )?.value
                          : reportData?.riskcoordinator_id,
                      }
                    }
                    let res = await updateMyIncidentApi({
                      report_header_id: hederId,
                      data: data,
                    })
                    if (res?.status === 'success') {
                      history.go(0)
                    }
                  } else {
                    let report_attribute_value = reportTypeAttributes.map((item) => {
                      const dataTypeName = _.find(dataTypes, { id: item?.data_type_id })?.name
                      if (dataTypeName === 'dictionary') {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          report_attribute_value_id:
                            reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute_id === item?.report_type_attribute_id
                            )?.report_attribute_value_id || item?.report_attribute_value_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || '',
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || '',
                          is_locked: false,
                          report_header_id: hederId,
                          dictionary_value_code:
                            allDictionaryValues?.[item?.dictionary_id].find(
                              (dic) => dic.name === values[item?.report_type_attribute_code]
                            )?.code || null,
                        }
                      }
                      if (dataTypeName === 'date') {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          report_attribute_value_id:
                            reportData?.report_attribute_value.find(
                              (att) =>
                                att?.report_type_attribute_id === item?.report_type_attribute_id
                            )?.report_attribute_value_id || item?.report_attribute_value_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value: values[
                            item?.report_type_attribute_code
                          ]
                            ? moment(values[item?.report_type_attribute_code]).format('YYYY-MM-DD')
                            : '',
                          report_type_attribute_investigate_value: values[
                            item?.report_type_attribute_code
                          ]
                            ? moment(values[item?.report_type_attribute_code]).format('YYYY-MM-DD')
                            : '',
                          is_locked: false,
                          report_header_id: hederId,
                        }
                      }
                      if ([3, 4].includes(+item?.data_type_id)) {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || 0,
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || 0,
                          is_locked: false,
                        }
                      } else {
                        return {
                          report_type_id: id,
                          report_type_attribute_id: item?.report_type_attribute_id,
                          is_dictionary: dataTypeName === 'dictionary',
                          is_attachment: dataTypeName === 'attachment',
                          report_type_attribute_report_value:
                            values[item?.report_type_attribute_code] || '',
                          report_type_attribute_investigate_value:
                            values[item?.report_type_attribute_code] || '',
                          is_locked: false,
                        }
                      }
                    })
                    let res = await createMyIncidentApi({
                      risk_owner_company_id: [],
                      risk_owner_group_id: [],
                      risk_owner_bu_id: [],
                      risk_owner_division_id: [],
                      risk_owner_department_id: [],
                      risk_owner_section_id: [],
                      ...convertOrganizationalStructureToFilters(values?.risk_owner_company_id, [
                        'risk_owner_company_id',
                        'risk_owner_group_id',
                        'risk_owner_bu_id',
                        'risk_owner_division_id',
                        'risk_owner_department_id',
                        'risk_owner_section_id',
                      ]),
                      report_status_id: 1,
                      report_type_id: id,
                      reporter_id: +user_id,
                      incident_topic: values?.incident_topic,
                      riskcoordinator_id: isCentralReporter
                        ? riskcoList.find(
                            (item) =>
                              item?.label === values?.risk_co || item?.value === values?.risk_co
                          )?.value
                        : riskCo?.user_id,
                      assignee_id: +user_id,
                      // report_date: moment().format('YYYY-MM-DD'),
                      report_date: moment().format(),
                      business_process_id: values?.section,
                      report_attribute_value,
                      report_header_impact_level: [],
                      risk_owner_org: values?.risk_owner_org,
                      risk_owner_user_id: values?.risk_owner_user_id || [],
                    })
                    if (res?.status === 'success' && res?.data?.report_header_id) {
                      history.push(`/incident-report/${id}/${res?.data?.report_header_id}`)
                      if (res?.status === 'success') {
                        history.go(0)
                      }
                    }
                  }
                },
              })
            } else if (action === 'reject') {
              setIsModalRejectOpen(true)
            } else if (action === 're-open') {
              let res = await updateReOpenMyIncidentApi({ report_header_id: hederId })
              if (res?.status === 'success') {
                history.go(0)
              }
            }
          }}
          onFinishFailed={(values) => {
            console.log('error', values)
            let msg = []
            let error = values?.errorFields
            error.map((e, i) => {
              console.log(e)
              if (e.errors[0]) {
                msg.push(e.errors[0])
              }
              return e
            })
            ModalAntd.error({
              title: 'ไม่สามารถบันทึกได้',
              content: (
                <>
                  {msg.map((m) => (
                    <div>- {m}</div>
                  ))}
                </>
              ),
            })
          }}
        >
          {/* <Form.Item label={t('Report Status')} name='reportStatus'>
            <Select
              showSearch
              options={_.map(reportStatuses, (reportStatus) => {
                return {
                  label: reportStatus?.name,
                  value: reportStatus?.id,
                }
              })}
              filterOption={(input, option) => {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
            />
          </Form.Item> */}
          {header}
          <Affix offsetTop={80}>
            <Radio.Group
              optionType='button'
              buttonStyle='solid'
              onChange={(e) => {
                setRadioValue(e?.target?.value)
              }}
              value={radioValue}
              options={[
                { label: t('Report'), value: 'report' },
                {
                  label: t('Investigation'),
                  value: 'investigation',
                  disabled: !reportData?.report_header_id,
                },
                {
                  label: t('Request Info'),
                  value: 'invite',
                  disabled: !reportData?.report_header_id,
                },
                {
                  label: t('Action Plan'),
                  value: 'actionPlan',
                  disabled: !reportData?.report_header_id,
                },
              ]}
            />
          </Affix>
          {+reportStatusId === 5 && isRiskAnalyst && radioValue === 'report' ? (
            <Button
              shape='round'
              type='primary'
              style={{ marginTop: 8, marginBottom: 0 }}
              onClick={() => recovery()}
            >
              Recovery Data
            </Button>
          ) : null}
          {radioValue === 'report'
            ? reportStatuses
                .filter((st) => st?.report_status_order <= form.getFieldValue('reportStatus'))
                .map((st) => <div style={{ height: '100%' }}>{genReport(st)}</div>)
            : null}
          {radioValue === 'invite' ? (
            <Invite report_header_id={reportData?.report_header_id} disabled={!canEdit} />
          ) : null}
          {radioValue === 'actionPlan' ? (
            <ActionPlan reportHeaderId={reportData?.report_header_id} disabled={!canEdit} />
          ) : null}
          {radioValue === 'investigation' ? (
            <Investigation
              report_id={reportData?.report_header_id}
              report_status={reportData?.report_status_id}
              report_data={reportData?.report_header_impact_level}
              disabled={!canEdit}
              set_reportImpactLevel={(data) => {
                console.log('sIM aveoverAllReport', data)
                setReportImpactLevel(data)
              }}
              set_reportOverall={(data) => {
                console.log('aa saveoverAllReport', data)
                setReportOverall(data)
              }}
              setOpenReportOverall={() => setOpenReportOverall(true)}
              isReportOwnself={isReportOwnself}
              reportImpactLevelHead={reportImpactLevel}
              reportOverallHead={reportOverall}
              default_is_significant={reportData?.is_significant}
            />
          ) : null}
        </Form>
        <ModalAntd
          title='เหตุผลของการ Reject'
          visible={isModalRejectOpen}
          footer={null}
          // onCancel={setIsModalRejectOpen(false)}
        >
          <>
            <Form.Item name='reject_text' id='reject_text' label='เหตุผลของการ Reject'>
              <InputAntd.TextArea
                id='reject_text'
                rows={4}
                style={{ color: 'black' }}
                onChange={(v) => {
                  setRejectDes(v?.target?.value)
                }}
              />
            </Form.Item>
            <Space size='middle'>
              <Button
                type='primary'
                disabled={reject_des.length === 0}
                onClick={async () => {
                  let res2 = await updateRejectMyIncidentApi({
                    report_header_id: hederId,
                    reject_description: document.getElementById('reject_text')?.value || '',
                  })
                  if (res2?.status === 'success') {
                    history.go(0)
                  }
                  setIsModalRejectOpen(false)
                }}
              >
                {t('Save')}
              </Button>
              <Button onClick={() => setIsModalRejectOpen(false)}>{t('Cancel')}</Button>
            </Space>
          </>
        </ModalAntd>
      </Spin>
    </Styled>
  )
}
